window.CLYDE = {
    // Global Cart configuration
    globalCart: {
      // Whether the feature is enabled
      enabled: true,
  
      // jQuery selector for the cart drawer container
      cartSelector: '#CartDrawer-CartItems',
  
      // jQuery selector for each item element contained within the cart drawer.
      // IMPORTANT: the item needs to either
      // 1) an anchor with a ?variant= query parameter in the href
      // 2) an element with a data-variant-id="" property indicating the variant ID of the item in cart
      // Only the product name link: each cart row has several anchors, and a selector that matches more than one per
      // line item makes Clyde's init think the UI and cart are out of sync and retry. The image link is aria-hidden,
      // which Clyde skips anyway.
      itemSelector: '.cart-item .cart-item__name',
    },
  
    // interface addition to solve the underlying issues:
    onBeforeInit: function (sdk) {
      sdk.setSkuMap((variantId) => {
        switch (variantId) {
          case 6936464293930:
          case 6944255311914:
          case 40579326476330:
          case 40549365579818:
          case 7470204190762:
          case 42112258113578:
          case 7470150451242:
          case 42111930597418:
          case 7475337363498:
          case 42144075841578:
          case 42094484848682:
          case 7466738450474:
            return 40424316600362;
          default:
            return variantId;
        }
      });
    },
  
    // Callback when the Clyde SDK is ready
    onInit: function (sdk) {
      // Clyde only injects its CTAs into whatever drawer markup exists when refresh() resolves, and never re-checks.
      // Several theme scripts re-render the drawer (renderContents, cart-drawer-items' async onCartUpdate, Hue, Replo,
      // sidebar shop), often after Clyde has already injected, which wiped the CTAs depending on network timing.
      // So: debounce refresh() until the drawer has settled, and re-run it whenever the drawer markup changes.
      let refreshTimer;
      const scheduleRefresh = function() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function() {
          Promise.resolve(sdk.refresh()).catch(function(error) {
            console.warn('[Clyde] refresh failed', error);
          });
        }, 300);
      };

      // Ignore Clyde's own insertions/removals so refresh() doesn't retrigger itself
      const isClydeNode = function(node) {
        return node.nodeType === 1 && !!node.closest('[class*="clyde"]');
      };

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        new MutationObserver(function(mutations) {
          const drawerChanged = mutations.some(function(mutation) {
            return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function(node) {
              return node.nodeType === 1 && !isClydeNode(node);
            });
          });
          if (drawerChanged) scheduleRefresh();
        }).observe(cartDrawer, { childList: true, subtree: true });
      }

      // REQUIRED: When Clyde makes changes to the cart, the merchant implementation
      // will need to refresh/re-render the cart drawer
      sdk.on('update', function() {
        // Note: The logic here is basically copied from the file cart-drawer.js function `renderContents`. That existing
        // function requires a response from a /cart/add request, which we don't have access to in this context.
        const pageCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        pageCart.querySelector('.drawer__inner').classList.contains('is-empty')
          && pageCart.querySelector('.drawer__inner').classList.remove('is-empty');
  
        const slideCartSectionElement = document.querySelector('.drawer__inner');
        const countSectionElement = document.querySelector('.shopify-section');
  
        fetch(`/cart?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const content = html.querySelector('cart-drawer');
            slideCartSectionElement.innerHTML = pageCart.getSectionInnerHTML(responseText, '.drawer__inner');
            // The re-render above wipes the CTAs Clyde just injected; re-attach them
            scheduleRefresh();
          })
      });

      // REQUIRED: call refresh() when the cart changes
      // (products are added/removed or the quantity changes)
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
  };